import accorditon from './accorditon';
import hero_banner from './hero-banner';
import marquee from './marquee';
import side_by_side from './side-by-side';
import icon_grid from './icon-gird';
import carousel from './carousel';
import feature_grid_media from './feature-grid-media';
import freestyle_content from './freestyle_content';
import review_list from './review_list';
import text_media_stack from './text-media-stack';
import media_center_grid from './media-center-grid';

const strategies = [
  accorditon,
  hero_banner,
  marquee,
  side_by_side,
  icon_grid,
  carousel,
  feature_grid_media,
  freestyle_content,
  freestyle_content,
  review_list,
  text_media_stack,
  media_center_grid,
];

export const strategyRegistry = Object.fromEntries(strategies.map(s => [s.crawlType, s]));
